import Globe from './Globe';

export default Globe;
